import styled, { css } from 'styled-components';

export const Content = styled.div`
  display: flex;
  align-items: center;
  button {
    margin-right: 7px;
    line-height: 30px;
    line-height: 1.1;
  }
`;

export const PopupPlace = styled.div`
  position: relative;
  /* width: 230px; */
  /* .active {
    width: 230px;
  } */
`;

export const Popup = styled.div`
  box-shadow: 0 -2px 10px 2px rgba(204, 204, 204, 0.1);
  padding: 10px;
  background: #fff;
  position: absolute;
  left: -5px;
  bottom: 30px;
  button {
    white-space: nowrap;
    margin: 0 0 5px;
    width: 230px;
  }
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      background: #333;
    `}

  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      background: var(--cp-surface);
      color: var(--cp-text);
      border: 1px solid var(--cp-border);
    `}
`;
